import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #f9fafb;
  padding: 20px;
`;

export const LanguageSelectorWrapper = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 10;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 550px;
  padding: 40px;
  background-color: white;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  animation: ${fadeIn} 0.8s ease-out;

  & > * {
    margin-bottom: 20px;
  }

  p {
    color: #6b7280;
    line-height: 1.6;
    font-size: 16px;
    margin-bottom: 32px;
  }

  @media (max-width: 640px) {
    padding: 30px 20px;
  }
`;

export const LogoContainer = styled.div`
  margin-bottom: 36px;
  animation: ${fadeIn} 0.6s ease-out;

  img {
    max-width: 100%;
    height: auto;
  }
`;

export const Subtitle = styled.h2`
  font-size: 28px;
  font-weight: 600;
  color: #374151;
  margin: 12px 0 24px;

  @media (max-width: 640px) {
    font-size: 24px;
  }
`; 